import React, { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  itemId: string;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ProDocItemErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ProDocItem rendering error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            padding: '16px',
            margin: '8px 0',
            borderRadius: '8px',
            background: '#FEF2F2',
            border: '1px solid #FCA5A5',
          }}
        >
          <div
            style={{
              color: '#991B1B',
              fontFamily: 'Instrument Sans',
              fontSize: '14px',
              fontWeight: 600,
              marginBottom: '4px',
            }}
          >
            Failed to render item
          </div>
          <div
            style={{
              color: '#7F1D1D',
              fontFamily: 'Instrument Sans',
              fontSize: '12px',
            }}
          >
            {this.state.error?.message || 'Unknown error'}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ProDocItemErrorBoundary;
